<template>
  <div v-if="links.length > 3">


    <div class="flex flex-wrap -mb-1">
<!--      <select-input v-model="modelValue"  class="p-0  mr-5 w-1/4 lg:w-1/12" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)"-->
<!--      >-->
<!--        <option v-if="total>15" value="15">15 / {{total}}</option>-->
<!--        <option v-if="total>30" value="30">30 / {{total}}</option>-->
<!--        <option v-if="total>50" value="50">50 / {{total}}</option>-->
<!--        <option v-if="total>100" value="100">100 / {{total}}</option>-->
<!--        <option v-if="total>100" :value="total">{{total}} / {{total}}</option>-->
<!--      </select-input>-->
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded" v-html="link.label" />
        <Link v-else :key="`link-${key}`" class="mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:bg-white border focus:border-indigo-500 rounded" :class="{ 'bg-white': link.active }" :href="link.url" v-html="link.label" />
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
    Link,
    SelectInput
  },
  props: {
    links: Array,
    modelValue: String,
    total: Number
  },
}
</script>
